import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { reducer } from '../reducer';
import { mapDispatchToProps } from '../container';
import { MapOverviewPreview } from './preview';
import { withSettings } from '../withSettings';
const mapStateToProps = (state, props) => {
    const componentMapIdent = state[props.componentIdent].map;
    return {
        ...state[props.componentIdent],
        mapIdent: componentMapIdent,
        layers: state[props.componentIdent].layers,
        scale: state[componentMapIdent] && state[componentMapIdent].scale, // asby se pri zmene mapy aktualizovalo
        isChecked: !state[props.componentIdent].isHidden,
    };
};
export const MapOverviewPreviewContainer = compose(withReducer(reducer), connect(mapStateToProps))(MapOverviewPreview);
export const MapOverviewFormContainer = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings());
//# sourceMappingURL=container.js.map